module.exports = __webpack_public_path__ + "static/img/kof14-logo.02bd29e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/kof14-logo.png
// module id = oYxD
// module chunks = 0